const fullpageScroll = () => {
  const root = document.querySelector('.js-fullpage-scroll');
  const sections = Array.from(
    document.querySelectorAll('.js-fullpage-section'),
  );
  const pagination = document.querySelector('.js-fullpage-pagination');

  if (!root || sections.length < 2 || !pagination) return;

  const buttons = Array.from(
    pagination.querySelectorAll('.m-lp-pagination__item[data-target]'),
  );
  if (buttons.length === 0) return;
  const innerScrollSections = sections.filter((section) =>
    section.classList.contains('js-fullpage-section--inner-scroll'),
  );
  const footer = document.querySelector('.l-page__footer');

  const activate = (sectionId) => {
    buttons.forEach((button) => {
      const isActive = button.dataset.target === sectionId;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activate(entry.target.id);
        }
      });
    },
    {
      root,
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0,
    },
  );

  sections.forEach((section) => observer.observe(section));

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('.wpcf7, form')) return;

      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;

      const target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    },
    true,
  );

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetId = button.dataset.target;
      if (!targetId) return;
      const target = document.getElementById(targetId);
      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  });

  const EPSILON = 1;
  const TOUCH_THRESHOLD = 12;
  let isSectionTransitioning = false;

  const moveToSiblingSection = (section, direction) => {
    if (isSectionTransitioning) return false;

    const sibling =
      direction === 'prev'
        ? section.previousElementSibling
        : section.nextElementSibling;

    if (sibling && sibling.classList.contains('js-fullpage-section')) {
      isSectionTransitioning = true;
      sibling.scrollIntoView({ behavior: 'smooth', block: 'start' });

      window.setTimeout(() => {
        isSectionTransitioning = false;
      }, 500);

      return true;
    }

    // 最終セクションの内部スクロール終端から footer へ遷移させる
    if (direction === 'next' && footer) {
      isSectionTransitioning = true;
      footer.scrollIntoView({ behavior: 'smooth', block: 'start' });

      window.setTimeout(() => {
        isSectionTransitioning = false;
      }, 500);

      return true;
    }

    return false;
  };

  innerScrollSections.forEach((section) => {
    let touchStartY = 0;

    section.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true },
    );

    section.addEventListener(
      'touchmove',
      (event) => {
        if (event.touches.length !== 1) return;

        const currentY = event.touches[0].clientY;
        const deltaY = touchStartY - currentY;
        if (Math.abs(deltaY) < TOUCH_THRESHOLD) return;

        const maxScrollTop = section.scrollHeight - section.clientHeight;

        if (maxScrollTop <= 0) {
          if (deltaY < 0) {
            const moved = moveToSiblingSection(section, 'prev');
            if (moved) {
              event.preventDefault();
            }
          } else {
            const moved = moveToSiblingSection(section, 'next');
            if (moved) {
              event.preventDefault();
            }
          }
          return;
        }

        const isAtTop = section.scrollTop <= EPSILON;
        const isAtBottom = section.scrollTop >= maxScrollTop - EPSILON;

        if (deltaY < 0 && isAtTop) {
          const moved = moveToSiblingSection(section, 'prev');
          if (moved) {
            event.preventDefault();
          }
        }

        if (deltaY > 0 && isAtBottom) {
          const moved = moveToSiblingSection(section, 'next');
          if (moved) {
            event.preventDefault();
          }
        }
      },
      { passive: false },
    );

    section.addEventListener(
      'wheel',
      (event) => {
        const { deltaY } = event;
        if (deltaY === 0) return;

        const maxScrollTop = section.scrollHeight - section.clientHeight;

        if (maxScrollTop <= 0) {
          if (deltaY < 0) {
            const moved = moveToSiblingSection(section, 'prev');
            if (moved) {
              event.preventDefault();
            }
          } else {
            const moved = moveToSiblingSection(section, 'next');
            if (moved) {
              event.preventDefault();
            }
          }
          return;
        }

        const isAtTop = section.scrollTop <= EPSILON;
        const isAtBottom = section.scrollTop >= maxScrollTop - EPSILON;

        if (deltaY < 0 && isAtTop) {
          const moved = moveToSiblingSection(section, 'prev');
          if (moved) {
            event.preventDefault();
          }
        }

        if (deltaY > 0 && isAtBottom) {
          const moved = moveToSiblingSection(section, 'next');
          if (moved) {
            event.preventDefault();
          }
        }
      },
      { passive: false },
    );
  });
};

export { fullpageScroll };
